<template>
  <layout-content>
    <template slot="header">
      <div class="db-title">
        {{ title }}
      </div>
    </template>

    <template slot="top-buttons">
      <!-- <recipients-import-btn :database_id="database_id" /> -->
      <i-button size="large" type="default" icon="md-arrow-down" @click="make_import">
        {{ $t('db.recipient.button.import') }}
      </i-button>

      <tooltip
        class="ml-3"
        placement="bottom"
        min-width="250"
        max-width="250"
        theme="light"
        :content="$t(tooltip_text)"
      >
        <i-button
          size="large"
          type="default"
          icon="md-arrow-up"
          :disabled="!is_export"
          @click="make_export"
        >
          {{ $t('db.recipient.button.export') }}
        </i-button>
      </tooltip>

      <i-button class="ml-3" size="large" type="primary" @click="create">
        {{ $t('db.recipient.button.create') }}
      </i-button>
    </template>

    <recipient-filter :database_id="database_id" />

    <recipient-table :database_id="database_id" />
  </layout-content>
</template>

<script>
  import { DataBaseService } from '@db/services/DataBaseService';
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import { RecipientModalService } from '@db/modals/RecipientModalService';
  import RecipientFilter from '@db/components/recipients/recipients-table-filter';
  import RecipientTable from '@db/components/recipients/recipients-table';
  // import RecipientsImportBtn from '@db/components/recipients/recipients-import-btn';

  export default {
    components: {
      // RecipientsImportBtn,
      RecipientFilter,
      RecipientTable
    },

    data: () => ({
      title: ''
    }),
    computed: {
      ...mapGetters('core/auth', ['token']),
      ...mapGetters('core/auth', ['permissions']),
      ...mapGetters('db/databases/show/recipients', ['recipients']),

      database_id() {
        return this.$route.params.id;
      },

      is_export() {
        const is_export = this.permissions.service_database_export_is_allowed;
        const recipients = this.recipients;

        if (is_export && recipients > 0) return true;

        return false;
      },
      tooltip_text() {
        const export_not_allowed = !this.permissions.service_database_export_is_allowed;
        const empty_db = this.recipients == 0;

        if(export_not_allowed) {
          return 'autocaller_v2.campaign.tooltips.need_support'
        } else if (empty_db) {
          return 'autocaller_v2.campaign.tooltips.empty_data'
        } 
        return 'db.tooltips.export_your_db'
      }
    },
    created() {
      const id = this.database_id;
      this.set_database_id(id);
      DataBaseService.getItem(id)
        .then((res) => {
          this.title = res['name'];
          this.add_breadcrumbs({
            item: {
              title: res['name'],
              route: '#'
            }
          });
        })
        .finally(() => this.endLoadingPage());
    },
    beforeDestroy() {
      this.set_database_id(null);
    },
    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcrumbs: 'add_item' }),
      ...mapActions('db/databases/show/recipients', ['getAsyncData']),
      ...mapMutations({
        set_database_id: 'db/databases/show/database_id'
      }),

      create() {
        this.$router.push({
          name: 'db.database.recipient.create',
          params: { database_id: this.database_id }
        });
      },

      make_export() {
        RecipientModalService.make_export(this.database_id);
      },

      make_import() {
        RecipientModalService.make_import(this.database_id, this.token);
      }
    }
  };
</script>

<style lang="scss">
  .db-title {
    white-space: nowrap;
    width: 440px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
